import React from "react";

import { Modal } from "components/Modal";
import { UsdeeuuBridgeFormModalProps } from "./types";
import { UsdeeuuBridgeFormSlider } from "components/UsdeeuuBridgeFormSlider";

export const UsdeeuuBridgeFormModal: React.FC<UsdeeuuBridgeFormModalProps> = ({
  isOpen,
  onDismiss,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onWillDismiss={onDismiss}
      withArrow={false}
      classNameModalWrapper="letsbit-tight-modal"
    >
      <UsdeeuuBridgeFormSlider onDimiss={onDismiss} isOpen={isOpen} />
    </Modal>
  );
};
